import { AcademicLeague } from "@/types/battle"
import { CityMapItem } from "@/types/location"
import {
  CityPolygonPoint,
  parseCityPolygon,
} from "@/features/passport/guardiansCity"

export type CityMapPolygon = {
  cityId: number
  title: string
  isOwnCity: boolean
  polygon: CityPolygonPoint[]
  dominantLeague?: AcademicLeague
}

export function citiesToMapPolygons(
  cities: CityMapItem[],
  ownCityDominantLeague?: AcademicLeague | null
): CityMapPolygon[] {
  return cities
    .filter((city) => city.polygon.length >= 3)
    .map((city) => ({
      cityId: city.cityId,
      title: city.title,
      isOwnCity: city.isOwnCity,
      polygon: parseCityPolygon(city.polygon),
      ...(city.isOwnCity && ownCityDominantLeague
        ? { dominantLeague: ownCityDominantLeague }
        : {}),
    }))
    .filter((city) => city.polygon.length >= 3)
}
